import { cn } from "@/common/utils";

export default function DocumentsTabElement({
  label,
  tabIcon,
  isActive,
}: {
  label: string;
  tabIcon: JSX.Element;
  isActive: boolean;
}) {
  return (
    <div
      className={cn(
        "h-[40px] rounded-lg px-[16px] py-[5px] gap-[3px] flex items-center justify-center text-[14px] font-kanit font-normal text-nowrap",
        isActive ? "bg-primary text-white" : "bg-primaryDim text-primary"
      )}
    >
      {tabIcon}
      {label}
    </div>
  );
}
